export default "__VITE_ASSET__1627ee06__"